import { useTranslation } from 'react-i18next';

interface ComingSoonProps {
  children: React.ReactNode;
}

/**
 * @graph-stack ux-mirror
 * @graph-domain UX
 * @graph-business 未実装機能のComing Soonオーバーレイ。子コンテンツ上にガラス背景で「準備中」を表示
 * @graph-connects none
 */
export function ComingSoon({ children }: ComingSoonProps) {
  const { t } = useTranslation();

  return (
    <div className="relative">
      {children}
      <div className="coming-soon-overlay">
        <p className="text-lg font-bold text-[var(--color-text-primary)] mb-1">
          {t('common.comingSoon')}
        </p>
        <p className="text-xs text-[var(--color-text-muted)]">
          {t('common.comingSoonDescription')}
        </p>
      </div>
    </div>
  );
}
